import TopNavigationLayoutPageContent from 'shared/Layouts/TopNavigationLayout/TopNavigationLayoutPageContent'
// import GradeFilters from './components/gradeTableFilters/GradeTableFilterts'
import GradeTable from './components/gradeTable/GradeTable'

const ProtectionGradePage = () => {
  return (
    <TopNavigationLayoutPageContent type='defaultWithBackButton'>
      <div className='flex-space-between' style={{ marginBottom: '1rem' }}>
        <div className='inline-flex-gap' style={{ gap: '2.5em' }}>
          <h2 className='page--header'>Оценки</h2>
        </div>
      </div>
      {/* <GradeFilters /> */}
      <GradeTable />
    </TopNavigationLayoutPageContent>
  )
}

export default ProtectionGradePage
